<template>
  <div class="personal-data">
    <h2 class="data-title">Geben Sie Ihre persönlichen Daten zur <br class="personal-tablet" /> Erfassung des Auftrags
      an</h2>

    <div class="content-wrapper">

      <div class="form-data-wrapper">
        <div>
          <p class="salutation"> <strong> Anrede* </strong> </p>
          <div class="form-group" :class="hasError('salutation') ? 'is-invalid' : ''">
            <div class="custom-control custom-radio custom-control-inline">
              <input id="frau" v-model="formData.salutation" type="radio" value="Frau" name="salutation"
                class="custom-control-input" :class="hasError('salutation') ? 'is-invalid' : ''">
              <label class="custom-control-label" for="frau">Frau</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input id="herr" v-model="formData.salutation" type="radio" value="Herr" name="salutation"
                class="custom-control-input" :class="hasError('salutation') ? 'is-invalid' : ''">
              <label class="custom-control-label" for="herr">Herr</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input id="divers" v-model="formData.salutation" type="radio" value="Divers" name="salutation"
                class="custom-control-input" :class="hasError('salutation') ? 'is-invalid' : ''">
              <label class="custom-control-label" for="divers">Divers</label>
            </div>
            <div v-if="hasError('salutation')" class="invalid-feedback">
              <div v-if="!$v.formData.salutation.required" class="error">
                Bitte wählen Sie eine Anrede aus.
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-6">
              <float-label>
                <input id="firstname" v-model="formData.firstname" type="text" class="form-control" maxlength="40"
                  :class="hasError('firstname') ? 'is-invalid' : ''" placeholder="Vorname*">
              </float-label>
              <div v-if="hasError('firstname')" class="invalid-feedback">
                <div v-if="!$v.formData.firstname.required" class="error">
                  Bitte geben Sie Ihren Vornamen an.
                </div>
              </div>
            </div>

            <div class="form-group col-6">
              <float-label>
                <input id="lastname" v-model="formData.lastname" type="text" class="form-control" maxlength="40"
                  :class="hasError('lastname') ? 'is-invalid' : ''" placeholder="Nachname*">
              </float-label>
              <div v-if="hasError('lastname')" class="invalid-feedback">
                <div v-if="!$v.formData.lastname.required" class="error">
                  Bitte geben Sie Ihren Nachnamen an.
                </div>
              </div>
            </div>
          </div>


          <div class="form-row">
            <div class="form-group col-9">
              <float-label>
                <input id="street" v-model="formData.street" type="text" class="form-control" maxlength="52"
                  :class="hasError('street') ? 'is-invalid' : ''" placeholder="Straße*">
              </float-label>
              <div v-if="hasError('street')" class="invalid-feedback">
                <div v-if="!$v.formData.street.required" class="error">
                  Bitte geben Sie Ihre Straße an.
                </div>
              </div>
            </div>
            <div class="form-group col-3">
              <float-label>
                <input id="number" v-model="formData.number" type="text" class="form-control" 
                  :class="hasError('number') ? 'is-invalid' : ''" maxlength="10" minlength="1" placeholder="Nr.*">
              </float-label>

              <div v-if="hasError('number')" class="invalid-feedback">
                <div v-if="!$v.formData.number.required" class="error">
                  Bitte geben Sie Ihre Hausnummer an.
                </div>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-4">
              <float-label>
                <input id="zip" v-model="formData.zip" type="text" class="form-control"
                  :class="hasError('zip') ? 'is-invalid' : ''" placeholder="PLZ*" maxlength="8">
              </float-label>
              <div v-if="hasError('zip')" class="invalid-feedback">
                <div v-if="!$v.formData.zip.required" class="error">
                  Bitte geben Sie Ihre Postleitzahl an.
                </div>
                <div v-if="!$v.formData.zip.numeric || !$v.formData.zip.maxLength || !$v.formData.zip.minLength"
                  class="error">
                  Bitte geben Sie eine gültige Postleitzahl an.
                </div>
              </div>
            </div>
            <div class="form-group col-8">
              <float-label>
                <input id="city" v-model="formData.city" type="text" class="form-control" maxlength="35"
                  :class="hasError('city') ? 'is-invalid' : ''" placeholder="Stadt*">
              </float-label>

              <div v-if="hasError('city')" class="invalid-feedback">
                <div v-if="!$v.formData.city.required" class="error">
                  Bitte geben Sie Ihre Stadt an.
                </div>
              </div>
            </div>
          </div>

          <div class="form-group">
            <div class="select-wrapper">
              <float-label label="Land">
                <select id="country" v-model="defaultSelected" class="country-select"
                  :class="hasError('country') ? 'is-invalid' : ''">
                  <option value="" disabled selected>Land</option>
                  <option v-for="option in options" :value="option.code" :key="option.country">
                    {{ option.country }}
                  </option>
                </select>
              </float-label>
            </div>

            <div v-if="hasError('country')" class="invalid-feedback">
              <div v-if="!$v.formData.countryCode.required" class="error">
                Bitte wählen Sie ein Land aus.
              </div>
            </div>
          </div>

          <div class="form-group">
            <float-label>
              <input id="email" v-model="formData.email" type="email" class="form-control" maxlength="250"
                :class="hasError('email') ? 'is-invalid' : ''" placeholder="E-Mail*">
            </float-label>

            <div v-if="hasError('email')" class="invalid-feedback">
              <div v-if="!$v.formData.email.required" class="error">
                Bitte geben Sie Ihre E-Mail-Adresse an.
              </div>
              <div v-if="!$v.formData.email.email" class="error">
                Bitte geben Sie eine gültige E-Mail-Adresse an.
              </div>
            </div>
          </div>

          <div class="form-group">
            <float-label>
              <input id="phone" v-model="formData.phone" type="number" class="form-control" maxlength="50" minlength="1"
                :class="hasError('phone') ? 'is-invalid' : ''" placeholder="Telefonnummer*">
            </float-label>

            <div v-if="hasError('phone')" class="invalid-feedback">
              <div v-if="!$v.formData.phone.numeric || !$v.formData.phone.maxLength" class="error">
                Bitte geben Sie eine gültige Telefonnummer an.
              </div>
              <div v-if="!$v.formData.phone.required" class="error">
                Bitte geben Sie eine Telefonnummer an.
              </div>
            </div>
          </div>

          <div class="form-group" :class="hasError('contact') ? 'is-invalid' : ''">
            <span for="contact" class="d-flex align-items-center">
              <strong>
                Bevorzugte Kontaktzeit (Mo-Fr)
              </strong>
              <b-button variant="link" id="popover-contact" class="popover-btn">
                <img src="../../assets/images/info-i.svg" alt="Info Toggle" />
              </b-button>
              <b-popover class="default-tooltip" target="popover-contact"
                content="Wann können wir Sie werktags am besten bei Rückfragen erreichen?" triggers="hover focus"
                placement="topleft" style="background-color: #1A1A1A; color: #FFFFFF;"></b-popover>
            </span>

            <div class="contact-time-wrapper">
              <div class="contact-time-item custom-checkbox">
                <label for="contact1" class="check-container">
                  <b-checkbox id="contact1" v-model="formData.contact" type="checkbox" value="9-11 Uhr"
                    class="contact-time" :class="hasError('contact') ? 'is-invalid' : ''"></b-checkbox>
                </label>
                <p>zwischen 9:00 und 11:00 Uhr </p>
              </div>
              <div class="contact-time-item custom-checkbox">
                <label for="contact2" class="check-container">
                  <b-checkbox id="contact2" v-model="formData.contact" type="checkbox" value="11-14 Uhr"
                    class="contact-time" :class="hasError('contact') ? 'is-invalid' : ''"> </b-checkbox>
                </label>
                <p>zwischen 11:00 und 14:00 uhr</p>
              </div>
              <div class="contact-time-item custom-checkbox">
                <label for="contact3" class="check-container">
                  <b-checkbox id="contact3" v-model="formData.contact" type="checkbox" value="14-17 Uhr"
                    class="contact-time" :class="hasError('contact') ? 'is-invalid' : ''"></b-checkbox>
                </label>
                <p>zwischen 14:00 und 17:00 Uhr</p>
              </div>

            </div>
            <div v-if="hasError('contact')" class="invalid-feedback">
              <div v-if="!$v.formData.contact.required" class="error">
                Bitte geben Sie eine Kontaktzeit an damit wir Sie bei Rückfragen kontaktieren können.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { required, email, maxLength, minLength, numeric } from 'vuelidate/lib/validators'
import "vue-select/dist/vue-select.css";

export default {
  name: 'PersonalData',
  validations: {
    formData: {
      salutation: { required },
      firstname: { required },
      lastname: { required },
      countryCode: { required },
      street: { required },
      number: { required },
      zip: { required, numeric, maxLength: maxLength(5), minLength: minLength(5) },
      city: { required },
      phone: { required, numeric, maxLength: maxLength(50) },
      email: { required, email },
      contact: { required, minValue: 1 }
    }
  },
  data() {
    return {
      defaultSelected: "DE",
      options: [{ country: "Deutschland", code: "DE" }]
    }
  },
  computed: {
    formData: {
      get() {
        return this.$store.state.checkoutFormData
      },
      set(value) {
        this.$store.commit('updateCheckoutFormData', value)
      }
    }
  },
  mounted() {
    this.$store.commit('setValidation', this.$v)
    this.formData.countryCode = this.options[0].code;
  },
  methods: {
    hasError(fieldName) {
      return (
        fieldName in this.$v.formData &&
        this.$v.formData[fieldName].$error
      )
    }
  }
}
</script>

<style lang="scss">
#contact1-label,
#contact2-label,
#contact3-label {
  padding: 0.5rem !important;
  max-width: 200px !important;
  min-width: 200px !important;
}

.form-group {
  border-color: #666666 !important;
}

#country-form {
  display: flex;

  #country {
    width: 50% !important;
  }

  #country-label {
    margin-left: 1rem;
    margin-top: 4px;
    max-width: 45% !important;
  }
}
</style>
